import "ress";
import "./styles/index.scss";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Copyright from "./components/parts/Copyright.vue";
import SoundController from "./scripts/SoundController";

// 右クリック抑制
document.oncontextmenu = function() {
  return false;
};

Vue.config.productionTip = false;

// global component
Vue.component("Copyright", Copyright);

Vue.mixin({
  methods: {
    tapSound() {
      // 共通ボタンタップ音
      // SoundController.playSound("tap");
    },
    playSound(key) {
      SoundController.playSound(key);
    },
  },
  mounted: function() {
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
  },
});

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");

// https://github.com/vuejs/vue-router/issues/729#issuecomment-252174736
// @Samuell1 For now, as a work around, you can manually call router.replace('/'), see example below.
// https://jsfiddle.net/qpnaokhf/
router.replace("/");
